export default {"src":"/uk/_next/static/media/blob-deny.0ea1c873.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};